import axios from 'axios'
import React, { useEffect, useState } from 'react'
import NoDataFound from '../utilsComponent/noDataFound'
import { REACT_APP_KSHEMA_POC2, REACT_APP_VAM_CONTEXT_INDEMNITY, REACT_APP_VAM_ENDPOINT } from '../urls'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import { editModeOn, getFromDecreaptLocalStorage, selectedproductName } from '../utilFunctions'
import ListsPagination from '../utilsComponent/ListsPagination'
import { axiosRequest } from '../service'
import { functionalities } from '../consts'


function IndemnityMaster(props) {
    const {roleDataCookie, productNames} = props
    const [indemnityLists, setIndemnityLists] = useState([])
    const [showAddPopover, setShowAddPopover] = useState(false);
    const [showEditPopover, setShowEditPopover] = useState(false);
    const [editMode, setEditMode] = useState(false)
    const [sortedProductId, setSortedProductId] = useState(true)
    const [sortedIndemnity, setSortedIndemnity] = useState(true)
    const [sortedProductName, setSortedProductName] = useState(true);
    const [currentItems, setCurrentItems] = useState([])
    const defaultPayload = {
        id: null,
        createdBy : roleDataCookie?.userID,
        startDate : null,
        endDate : null,
        indemnityPercentage : 0,
        productID : null,
    }
    const [indemnityPayload, setIndemnityPayload] = useState(defaultPayload)

    useEffect(() => {
        getIndemnityLists()
    }, [])

    const getIndemnityLists = () => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INDEMNITY}/getAllIndemnities`).then(data => {
            setIndemnityLists(data.data)
        }).then(error => {
            console.log(error)
        })
    }

    const hanldeDatechange = (date, key) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const dat1 = (date.getDate()).toString().padStart(2, '0')
            setIndemnityPayload({ ...indemnityPayload, [key]: `${year}-${month}-${dat1}` })
        }
    }
    const addIdemnityMaster = () => {
        if(!indemnityPayload.productID){
            toast.error("Please Select Product Name.")
            return
        }else if(!indemnityPayload.indemnityPercentage){
            toast.error("Please Enter Excess Percentage.")
            return
        }else if(!indemnityPayload.startDate){
            toast.error("Please Select Start Date.")
            return
        }else if(!indemnityPayload.endDate){
            toast.error("Please Select End Date.")
            return
        }else{
            if(editMode){
                axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INDEMNITY}/updateIndemnity`,{
                    ...indemnityPayload,
                    productID: indemnityPayload.productID.value,
                }).then(data => {
                    setEditMode(false)
                    setIndemnityPayload(defaultPayload)
                    getIndemnityLists()
                    data.data === "The requested date range overlaps with the existing range." ? toast.error(data.data) : toast.success(data.data)
                    setShowAddPopover(false)
                }).catch(error => (
                    console.log(error)
                )
                )
            }else{
                axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INDEMNITY}/createIndemnity`,{
                    ...indemnityPayload,
                    productID: indemnityPayload.productID.value,
                }).then(data => {
                    setIndemnityPayload(defaultPayload)
                    getIndemnityLists()
                    data.data === "The requested date range overlaps with the existing range." ? toast.error(data.data) : toast.success(data.data)
                    setShowAddPopover(false)
                }).catch(error => (
                    console.log(error)
                )
                )
            }
        }
    }
    const clickedOnEditMode = (data) => {
        setIndemnityPayload({   
            "id": data.id,
            "productID": data.productID,  
            "indemnityPercentage": data.indemnityPercentage,  
            "startDate": data.startDate,  
            "endDate": data.endDate,  
            "createdBy": roleDataCookie?.userID
        })
        setEditMode(true);
        setShowAddPopover(true)
    }

    const handleAdd = () => {
        setShowAddPopover(!showAddPopover);
    };
    const addIdemnity = () => {
        setIndemnityPayload(defaultPayload)
        setShowAddPopover(!showAddPopover)
        setEditMode(false)
    }
    const sortingData = (data) => {
        switch (data) {
         case "sortedProductId":
             if (!sortedProductId) {
                 const lists = [...indemnityLists]
                 lists.sort((a, b) => a.productID - b.productID)
                 setIndemnityLists([...lists])
                 setSortedProductId(true)
             } else {
                 const lists = [...indemnityLists]
                 lists.sort((a, b) => b.productID - a.productID)
                 setIndemnityLists([...lists])
                 setSortedProductId(false)
             }
             break;
         case "sortedIndemnity":
             if (!sortedIndemnity) {
                 const lists = [...indemnityLists]
                 lists.sort((a, b) => a.indemnityPercentage - b.indemnityPercentage)
                 setIndemnityLists([...lists])
                 setSortedIndemnity(true)
             } else {
                 const lists = [...indemnityLists]
                 lists.sort((a, b) => b.indemnityPercentage - a.indemnityPercentage)
                 setIndemnityLists([...lists])
                 setSortedIndemnity(false)
             }
             break;
            //  case "sortedProductName":
            //      if (!sortedProductName) {
            //        const lists = [...indemnityLists]
            //        lists.sort((a, b) => a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase()))
            //        setIndemnityLists([...lists])
            //        setSortedProductName(true)
            //      } else {
            //        const lists = [...indemnityLists]
            //        lists.sort((a, b) => b.lastName?.toLowerCase().localeCompare(a.lastName?.toLowerCase()))
            //        setIndemnityLists([...lists])
            //        setSortedProductName(false)
            //      }
            //      break;
       default:
     }
    
    }


    return (
        <section className="p-4">
            <h1 className="headerclaim">Indemnity Master:</h1>
            <hr className="upper_hr" />
            <div className="outer-box_vendorMasters">
                <div style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <h2 className="heading_h2Masters">Indemnity Master</h2>
                    {editModeOn(functionalities.INDEMNITY_MASTER_TAB) && (
                        <button className={'btn btn-success mt-4 mb-4 px-4'} onClick={() => addIdemnity()} style={{ marginRight: '2%' }}><i className="fa fa-plus" aria-hidden="false"></i> Add</button>
                    )}
                    <Modal show={showAddPopover} isOpen={showAddPopover} toggle={handleAdd} centered={true} backdrop={'static'}>
                        <ModalHeader>
                            {editMode ? <h5>Edit Indeminity</h5> : <h5>Add Indeminity</h5>}
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleAdd} ></button>
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group mb-3">
                                <form action>
                                    {
                                        !editMode && (
                                            <>
                                                <div className="form-group mb-3">
                                                <label for="exampleInputPassword1">Product Name</label>
                                                    <Select id="exampleInputPassword1" options={productNames}
                                                        onInputChange={(inputValue) => {
                                                            // Replace non-alphanumeric characters
                                                            const cleanedValue = inputValue.replace(/[^A-Za-z]/g, '');
                                                            return cleanedValue; // Return cleaned value for the Select component
                                                        }}
                                                        placeholder="Kshema Product"
                                                        value={indemnityPayload?.productID?.label ? indemnityPayload.productID : { label: "Product"}}
                                                        onChange={(data) => {                    
                                                            setIndemnityPayload({ ...indemnityPayload, 'productID': data })
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label for="indemnitypercentage" className="form-label">Indeminity %</label>
                                                    <input type="text" className="form-control" id="indemnitypercentage" placeholder="Indeminity %" onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                        e.target.value = numericValue;
                                                        setIndemnityPayload({ ...indemnityPayload, 'indemnityPercentage': Number(e.target.value) })
                                                    }} value={indemnityPayload.indemnityPercentage}/>
                                                </div>                                           
                                            </>
                                        )
                                    }
                                    <div className="form-group mb-3">
                                        <label for="validitystart" className="form-label">Validity Start</label>
                                         <div className='form-control'>
                                            <DatePicker
                                                selected={indemnityPayload?.startDate && indemnityPayload?.startDate}
                                                // className="align4_dataPolicy"
                                                maxDate={indemnityPayload?.endDate && indemnityPayload?.endDate}
                                                onChange={(date) => hanldeDatechange(date, 'startDate')}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="dd-mm-yyyy"
                                                // maxDate={new Date()}
                                                // highlightDates={new Date()}
                                                onKeyDown={(e) => e.preventDefault()}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdowns
                                                yearDropdownItemNumber={1000}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label for="validitystart" className="form-label">Validity End</label>
                                         <div className='form-control'>
                                            <DatePicker
                                                selected={indemnityPayload?.endDate && indemnityPayload?.endDate}
                                                // className="align4_dataPolicy"
                                                minDate={indemnityPayload?.startDate && indemnityPayload?.startDate}
                                                onChange={(date) => hanldeDatechange(date, 'endDate')}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="dd-mm-yyyy"
                                                // maxDate={new Date()}
                                                // highlightDates={new Date()}
                                                onKeyDown={(e) => e.preventDefault()}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={1000}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div></ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button style={{ borderColor: 'green', backgroundColor: '#157347', color: 'white' }} onClick={() => addIdemnityMaster()}>Save</Button>
                        </ModalFooter>
                    </Modal>
                    {/* <Modal show={showEditPopover} isOpen={showEditPopover} toggle={handleEdit} centered={true} backdrop={'static'}>
                        <ModalHeader>
                            <h5>Edit Indeminity</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleEdit}></button>
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group mb-3">
                                <form>
                                    <div className="form-group mb-3">
                                        <label htmlFor="validitystart" className="form-label">Validity Start</label>
                                        <input type="date" className="form-control" id="validitystart" />
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="validitystart" className="form-label">Validity End</label>
                                        <input type="date" className="form-control" id="validitystart" />
                                    </div>
                                </form>
                            </div>
                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button style={{ borderColor: 'green', backgroundColor: '#157347', color: 'white' }} onClick={handleSubmit}>Save</Button>
                        </ModalFooter>
                    </Modal> */}

                </div>
                {
                    indemnityLists && indemnityLists.length > 0 ? (
                        <>
                            <table className="table mt-3 text-left">
                                <thead style={{ border: '1px solid black' }}>
                                    <tr>
                                        <th style={{ border: '1px solid black' }}>S NO.</th>
                                        <th style={{ border: '1px solid black' }}>Product ID<a className="pointer text-body ms-1" onClick={() => sortingData("sortedProductId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                        <th style={{ border: '1px solid black' }}>Indemnity%<a className="pointer text-body ms-1" onClick={() => sortingData("sortedIndemnity")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                        <th style={{ border: '1px solid black' }}>Validity Start</th>
                                        <th style={{ border: '1px solid black' }}>Validity End</th>
                                        <th style={{ border: '1px solid black' }}>Product Name</th>
                                        {editModeOn(functionalities.INDEMNITY_MASTER_TAB) && (
                                            <th style={{ border: '1px solid black' }}>Action</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody style={{ border: '1px solid black' }}>
                                    {
                                        currentItems.map((list,index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid black' }}>{list.productID}</td>
                                                <td style={{ border: '1px solid black' }}>{list.indemnityPercentage}%</td>
                                                <td style={{ border: '1px solid black' }}>{format(new Date(list.startDate), 'dd-MMM-yyyy')}</td>
                                                <td style={{ border: '1px solid black' }}>{format(new Date(list.endDate), 'dd-MMM-yyyy')}</td>
                                                <td style={{ border: '1px solid black' }}>{selectedproductName(list.productID, productNames)?.label}</td>
                                                {editModeOn(functionalities.INDEMNITY_MASTER_TAB) && (
                                                    <td style={{ border: '1px solid black', backgroundColor: "#829ED1" }} onClick={() => { clickedOnEditMode(list) }} className='d-flex align-items-center justify-content-center'><FontAwesomeIcon icon="fas fa-edit" className='edit_button' /></td>
                                                )}
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <ListsPagination setCurrentItems={setCurrentItems} lists={indemnityLists}/>                           
                        </>
                    ) : <NoDataFound text="No Data Found" />
                }
            </div>
        </section>
    )
}

export default IndemnityMaster;